var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 27.2857C36 29.1791 34.4649 30.7143 32.5714 30.7143H3.42857C1.53514 30.7143 0 29.1791 0 27.2857V8.42857C0 6.53514 1.53514 5 3.42857 5H32.5714C34.4649 5 36 6.53514 36 8.42857V27.2857Z",
    fill: "#263B80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5C20.5109 10.5 18.6032 11.2902 17.1967 12.6967C15.7902 14.1032 15 16.0109 15 18C15 19.9891 15.7902 21.8968 17.1967 23.3033C18.6032 24.7098 20.5109 25.5 22.5 25.5C24.4891 25.5 26.3968 24.7098 27.8033 23.3033C29.2098 21.8968 30 19.9891 30 18C30 16.0109 29.2098 14.1032 27.8033 12.6967C26.3968 11.2902 24.4891 10.5 22.5 10.5Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5105 22.5C16.1625 22.0372 15.8632 21.537 15.6285 21H19.6222C19.8307 20.523 19.9942 20.022 20.1 19.5H15.1515C15.0525 19.0155 15 18.5145 15 18H20.25C20.25 17.4855 20.1975 16.9845 20.0992 16.5H15.1507C15.2572 15.978 15.42 15.477 15.6285 15H19.6222C19.3875 14.463 19.089 13.9627 18.7402 13.5H16.5105C16.8382 13.065 17.208 12.6585 17.6212 12.3038C16.3102 11.1818 14.6107 10.5 12.75 10.5C8.60775 10.5 5.25 13.8577 5.25 18C5.25 22.1422 8.60775 25.5 12.75 25.5C15.2017 25.5 17.3715 24.3187 18.7395 22.5H16.5105Z",
    fill: "#FF3D00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.4d7599fc70b21d9be9180e2775bf4295.svg";
export { ForwardRef as ReactComponent };